<template>
  <div  :class="{content_print_width: printStatue, bankruptcyBusiness: !printStatue}" v-wechat-title="$route.meta.title">
    <Header :class="{print_statue: printStatue}"/>
    <BannerBg :class="{print_statue: printStatue}"/>
    <div class="home_main_box">
      <div class="news_page_box pc_only">
        <div id="print_bankruptcyBusiness" :class="{site_print_width: printStatue, site_width: !printStatue}">
          <div class="site_width_h"> 
            <h2>业务领域</h2> 
          </div>
          <div class="site_width_y"> 
            <h2>{{ title }}</h2> 
          </div>
          <a class="pc_only" :class="{print_statue: printStatue}" @click="htmlCanvas" title="点击打印文章"><img style="float: right; padding-right: 25%;" src="@/assets/images/detail/print_small.png"> </a>
          <a class="pc_only" :class="{print_statue: printStatue}" @click="htmlCanvasPdf" title="点击下载文章"><img style="float: right; padding-right: 10px;" src="@/assets/images/detail/download_small.png"> </a>
          <div class="clear"></div>
          <el-tabs tab-position="left" @tab-click="tabHandleClick" v-model="editableTabsValue">
            <!--中间内容-->
            <div class="width9 watermark_columnContent" id="waterContentId" :class="{width100: printStatue}">
              <div class="padding_right15">
                <div class="padding15">
                  <div class="news_content">
                    <quill-editor
                    class="editor"
                    v-model="tableData.content"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorFocus($event)"
                    ></quill-editor>
                  </div>
                </div>
              </div>
            </div>
            <!--右侧内容-->
            <div class="width3" :class="{print_statue: printStatue}">
              <div class="right_ybline">
                <div class="padding_left15">
                  <h4 class="sub_title" :class="{print_statue: tableData.lawyersInfo == null}">相关律师</h4>
                  <ul class="team_list one_team_list">
                    <li v-for="item in tableData.lawyersInfo" :key="item.id">
                      <a @click="contentToLawyer(item.id)">
                        <div class="lawyer_pic">
                          <img :src=item.pic>
                        </div>
                        <div class="lawyer_int_txt">
                          <h3>{{ item.userName }}</h3>
                          <font>
                            - {{ item.qualification }}
                          </font>
                        </div>
                        <div class="clear"></div>
                      </a>
                    </li>
                    <div class="clear"></div>
                    </ul>
                  <div class="pc_only">
                    <h4 class="sub_title">手机分享</h4>
                    <div class="share_box">
                      <div id="qrcode">
                      </div>
                      <p>手机扫一扫
                        <br>分享给我的朋友</p>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear"></div>
            <el-tab-pane v-for="item in mobileParentData" :key="item.id" :label="item.name" :name="item.id.toString()">
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="news_page_box phone_only">
        <div class="site_width">
          <div class="site_width_hm"> 
            <h2>业务领域</h2> 
          </div>
          <el-tabs tab-position="top" @tab-click="tabHandleClick" v-model="editableTabsValue">
            <el-tab-pane v-for="item in mobileParentData" :key="item.id" :label="item.name">
            </el-tab-pane>
          </el-tabs>
          <div class="site_width_ym"> 
            <h2>{{ title }}</h2> 
          </div>
          <!--中间内容-->
          <div class="width9 watermark_columnContent" id="waterContentIds" :class="{width100: printStatue}">
            <div class="padding15">
              <div class="news_content">
                <quill-editor
                class="editor"
                v-model="tableData.content"
                ref="myQuillEditor"
                :options="editorOption"
                @focus="onEditorFocus($event)"
                @ready="onEditorFocus($event)"
                ></quill-editor>
              </div>
            </div>
          </div>
          <!--右侧内容-->
          <div class="width3" :class="{print_statue: printStatue}">
            <div class="right_ybline">
              <div class="padding15">
                <div class="padding_left15">
                  <h4 class="sub_title" :class="{print_statue: tableData.lawyersInfo == null}">相关律师</h4>
                  <ul class="team_list one_team_list">
                    <li v-for="item in tableData.lawyersInfo" :key="item.id">
                      <a @click="contentToLawyer(item.id)">
                        <div class="lawyer_pic">
                          <img :src=item.pic>
                        </div>
                        <div class="lawyer_int_txt">
                          <h3>{{ item.userName }}</h3>
                          <font>
                            - {{ item.qualification }}
                          </font>
                        </div>
                        <div class="clear"></div>
                      </a>
                    </li>
                    <div class="clear"></div>
                  </ul>
                  <div class="pc_only">
                    <h4 class="sub_title">手机分享</h4>
                    <div class="share_box">
                      <div id="qrcode">
                      </div>
                      <p>手机扫一扫
                        <br>分享给我的朋友</p>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clear"></div>
          <el-tab-pane v-for="item in mobileParentData" :key="item.id" :label="item.name" :name="item.id.toString()">
          </el-tab-pane>
        </div>
      </div>
    </div>
    <Footer :class="{print_statue: printStatue}"/>
  </div>
</template>

<script>
  const toolbarOptions = []
  import { quillEditor } from "vue-quill-editor"
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import QRCode from 'qrcodejs2'
  import html2Canvas from 'html2canvas'
  import JsPDF from 'jspdf'
  import { removeWatermark, setWaterMark } from '@/assets/js/watermark.js'
  export default {
    props: {
     /*编辑器的内容*/
     value: null
    },
    components: {
      quillEditor
    },
    name: "bankruptcyBusiness",
    data() {
      return {
        defaultImg: require('@/assets/images/news_default.jpg'),
        editableTabsValue: '15',
        editorOption: {
          theme: "bubble", // or 'bubble'
          placeholder: "",
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {}
            }
          }
        },
        pageParams: {
          columnId: 15,
          state: 0,
          pageNo: 1,
          pageSize: 1
        },
        routeParams: {
          columnId: 2,
          columnName: '破产业务',
          parentId: 0
        },
        tableData: {},
        printStatue: false,
        mobileParentData: [{
          id: 15,
          name: "破产管理人业务",
          parentId: 2
        },
        {
          id: 16,
          name: "债权申报业务",
          parentId: 2
        },
        {
          id: 17,
          name: "破产诉讼业务",
          parentId: 2
        },
        {
          id: 18,
          name: "清算业务",
          parentId: 2
        },
        {
          id: 19,
          name: "申请破产业务",
          parentId: 2
        },
        {
          id: 20,
          name: "破产重组企业顾问",
          parentId: 2
        },
        {
          id: 21,
          name: "意向投资人顾问",
          parentId: 2
        },
        {
          id: 22,
          name: "破产有关咨询",
          parentId: 2
        }],
        title: '破产管理人业务'
      }
    },
    mounted() {
      this.getColumnList()
    },
    methods: {
      onEditorFocus(editor) {
        // 富文本获得焦点时的事件
        editor.enable(false); // 在获取焦点的时候禁用
      },
      getColumnList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.COLUMN_PAGE_API_URL, 'Json', {
          parentId: 2,
          state: 0,
          pageNo: 1,
          pageSize: 20
        })
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.mobileParentData = res.data.data.list
            this.editableTabsValue = this.mobileParentData[0].id + ''
            this.title = this.mobileParentData[0].name
            if (this.$route.params.id) {
              let obj = {}
              obj = this.mobileParentData.find((item)=>{
                return item.id == this.$route.params.id
              })
              if (obj) {
                this.editableTabsValue = obj.id + ''
                this.pageParams.columnId = obj.id
                this.title = obj.name
              }
            }
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          this.isLoading = false
          this.$message.error("服务器出现差错")
        })
      },
      getPageList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.NEWS_PAGE_API_URL, 'Json', this.pageParams)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            window.scrollTo(0,0)
            this.qrcode()
            this.loadWaterMark()
            if(res.data.data.total > 0) {
              this.tableData = res.data.data.list[0]
              this.tableData.content = this.tableData.content.replace(' ', '&nbsp;')
            }
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      tabHandleClick(tab, event) {
        this.$router.push({
          path: '/bankruptcyBusiness/' + this.mobileParentData[tab.index].id
        })
        this.pageParams.columnId = this.mobileParentData[tab.index].id
        this.title = this.mobileParentData[tab.index].name
        this.getPageList()
      },
      // 二维码
      qrcode () {
        document.getElementById("qrcode").innerHTML="";
        var qrcodecontext = document.location.href;
        qrcodecontext = qrcodecontext.substring(0, 4).toLowerCase() == "http" ? qrcodecontext : "http://" + qrcodecontext;
        var qrnode = new QRCode('qrcode', { correctLevel: 0, text: qrcodecontext, width: 100, height: 100, background: "#fff", foreground: "#000" });
      },
      loadWaterMark() {
        removeWatermark()
        this.sendWaterMark()
      },
      sendWaterMark() {
        const _this = this
        setTimeout(function() {
          let width = $('.width9').width()
          let top = _this.printStatue ? 0 : $('.banner_bg').height()
          let height = $('.page_news_title').height() + $('.watermark_columnContent').height()
          setWaterMark('', '天津金展律师事务所', height, width, top)
        }, 200)
      },
      htmlCanvas() {
        document.getElementsByTagName('body')[0].style.height = '0px';
        document.getElementsByTagName('html')[0].style.height = '0px';
        window.scrollTo(0,0);
        this.printStatue = true;
        this.loadWaterMark();
        setTimeout(() => {
          window.print(); //  调用打印功能
          this.printStatue = false;
          this.loadWaterMark();
          document.getElementsByTagName('body')[0].style.height = '100%';
          document.getElementsByTagName('html')[0].style.height = '100%';
        }, 1000);
      },
      // 下载导出pdf 文件
      htmlCanvasPdf() {       
        document.getElementsByTagName('body')[0].style.height = '0px';
        document.getElementsByTagName('html')[0].style.height = '0px';
        window.scrollTo(0,0);
        this.printStatue = true;
        this.loadWaterMark();
        const _this = this
        setTimeout(() => {
          // 导出pdf
          let page = document.querySelector('#print_bankruptcyBusiness');
          var title = _this.tableData.title
          html2Canvas(page, {
            allowTaint: true,
            useCORS: true
          }).then(function(canvas) {
            let contentWidth = canvas.width
            let contentHeight = canvas.height
            let pageHeight = contentWidth / 592.28 * 841.89
            let leftHeight = contentHeight
            let position = 0
            let imgWidth = 595.28
            let imgHeight = 592.28 / contentWidth * contentHeight

            let pageData = new Image();
            //设置图片跨域访问
            pageData.setAttribute('crossOrigin', 'Anonymous');

            setTimeout(() => {
                pageData = canvas.toDataURL('image/jpeg', 1.0);
                let PDF = new JsPDF('', 'pt', 'a4')
                if (leftHeight < pageHeight) {
                    PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                } else {
                    while (leftHeight > 0) {
                        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                        leftHeight -= pageHeight
                        position -= 841.89
                        if (leftHeight > 0) {
                            PDF.addPage()
                        }
                    }
                }
                _this.printStatue = false;
                _this.loadWaterMark();
                document.getElementsByTagName('body')[0].style.height = '100%';
                document.getElementsByTagName('html')[0].style.height = '100%';
                PDF.save(title + '.pdf')
            }, 1000);
          })
        }, 1000);
      }
    }
  }
</script>
<style lang="less">
  .el-pagination {
    text-align: center; 
  }
  .ql-editor .ql-size-large {
    font-size: 14px;
  }
  .el-tabs__item {
    font-size: 15px;
  }
  .site_width_h h2 {
    width: 140px;
    float: left;
    text-align: right;
  }
  .site_width_y h2 {
    width: 240px;
    padding-left: 46px;
    float: left;
    color: #BF2A2A;
  }
  .site_width {
    max-width: 1300px;
  }
  .site_width_hm h2 {
    padding-left: 15px;
  }
  .site_width_ym h2 {
    padding-left: 15px;
    color: #BF2A2A;
  }
  .print_statue {
    display: none;
  }
</style>